// extracted by mini-css-extract-plugin
module.exports = {"header":"MinimalHeader_header__jmOYI","logo-container":"MinimalHeader_logo-container__Q88aO","logo":"MinimalHeader_logo__tfVDu","logo-image":"MinimalHeader_logo-image__YxsuZ"};